import { Component, Vue } from 'vue-property-decorator'
import {getMarketClueFollowList} from "@/api/common";
import {delNullProperty} from "@/utils";

@Component({})
export default class FollowRecord extends Vue {
    tableData = []
    page = 1
    limit = 20
    total = 0
    id: string;
    loading = false
    fsnumShow = true
    pageSize = 20
    timer = null

    created() {
        this.id = String(this.$route.query.id)
        this.getTableData()
    }

    async getTableData() {
        this.loading = true
        const data: any = await getMarketClueFollowList(delNullProperty({
            id: this.id,
            limit: this.limit,
            page: this.page
        }))

        this.total = data.allNum
        this.tableData = data.marketClueFollowList
        this.loading = false
    }


    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }
    pageSizeChange(val: number) {
        this.pageSize = val
        this.getTableData()
    }
}
